import type { MantineSize } from '@mantine/core';
import { Paper, useMantineTheme } from '@mantine/core';

interface AuthCardProps {
	children: React.ReactNode;
	p?: MantineSize;
	width?: string | number;
}

export function AuthCard({ children, p = '3xl', width = 480 }: AuthCardProps) {
	const theme = useMantineTheme();

	return (
		<Paper
			style={{
				display: 'flex',
				flexDirection: 'column',
				padding: p === '0' ? 0 : theme.spacing[p],
				borderRadius: theme.spacing.md,
				boxShadow: theme.shadows.lg,
				width: typeof width === 'number' ? `min(100vw, ${width}px)` : width,
				minWidth: theme.other.space[80],
				overflow: 'hidden',
			}}
		>
			{children}
		</Paper>
	);
}
